
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Qu’est-ce qu’un site Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article vous explique ce qu’est un Site Internet, quels sont les avantages pour votre entreprise. Il insiste également sur la nécessité d’une stratégie SEO pour en assurer les performances.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Qu’est-ce qu’un site Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique ce qu’est un Site Internet, quels sont les avantages pour votre entreprise. Il insiste également sur la nécessité d’une stratégie SEO pour en assurer les performances.",
        },
      ],
    };
  },
};
